import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

/**
 * DE · FR · IT in the public header, so visitors without an account can pick
 * their language too. Only while the `multilanguage` switch is on.
 */
@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [MatButton, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (languageService.selectable()) {
      <div
        role="group"
        class="flex items-center"
        [attr.aria-label]="'settings.language.title' | translate">
        @for (code of languageService.languages; track code) {
          <button
            mat-button
            type="button"
            class="!min-w-0 !px-2 uppercase !text-light-on-navy"
            [class.font-bold]="languageService.language() === code"
            [class.underline]="languageService.language() === code"
            [attr.aria-pressed]="languageService.language() === code"
            [attr.aria-label]="'language.' + code | translate"
            [attr.data-testid]="'language-' + code"
            (click)="pick(code)">
            {{ code }}
          </button>
        }
      </div>
    }
  `,
})
export class LanguageSwitchComponent {
  protected readonly languageService = inject(LanguageService);

  pick(code: (typeof this.languageService.languages)[number]): void {
    if (code !== this.languageService.language()) {
      this.languageService.setLanguage(code).subscribe();
    }
  }
}
